(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["coupon-code"] && !Shopify.designMode) return;
  try {
    
  const promo_code = document.getElementById('PromoCode');
  promo_code.addEventListener('click', (event) => {
  	navigator.clipboard.writeText(promo_code.innerText).then(() => {
      document.getElementById('PromoCodeMessage').classList.remove('hidden');
      document.getElementById('PromoCodeMessage').setAttribute('aria-hidden', false);

      setTimeout(() => {
        document.getElementById('PromoCodeMessage').classList.add('hidden');
        document.getElementById('PromoCodeMessage').setAttribute('aria-hidden', true);
      }, 6000);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
